/* eslint-disable */
import { getDomain } from "project-config/utils/domain";
import { getTimeZone } from "project-config/utils/format-time";
import { STORAGE } from "project-config/constants";
import Cookie from "project-config/utils/cookie";

export const CONST_HEADER = () => ({
  "Content-Type": "application/json",
  version: "1.0.0",
  signature: "rayvision2017",
  channel: 2,
  platform: sessionStorage.getItem(STORAGE.PLATFORM) || 0,
  sTraceId: sessionStorage.getItem(STORAGE.TRACE_ID_KEY) || "",
  languageFlag: Cookie.getCookie(STORAGE.LANGUAGE_FLAG) ?? getDomain(),
  timeZone: getTimeZone(),
});

export const CONST_ROUTE_ALLOWED_LISTS = ["/start"];

export const CONST_API_ALLOWED_LISTS = [
  "/api/rendering/socket/authSocketConnection",
  "/api/rendering/task/transfer/getTransferServerMsg",
  "/api/rendering/task/common/queryPlatforms",
  "/api/rendering/buriedpointdata/collector/post/data",
];

export const PASSWORD_ENCRYPT_LIST = [
  "/api/rendering/user/userLogin",
  "/api/rendering/user/register",
  "/api/rendering/user/abroadUserLogin",
  "/api/rendering/user/abroadRegister",
  "/api/rendering/user/activateAbroadRegisterUser",
  "/api/rendering/user/updatePassword",
  "/api/rendering/user/resetPasswordDomestic",
  "/api/rendering/user/resetPasswordAbroad",
  "/api/rendering/user/register/ThirdUser",
  "/api/rendering/user/addSubUser",
  "/api/rendering/user/modifySubUser",
  // sso for develop mode
  "/api/sso/sign/signIn",
  "/api/sso/child/login",
];

export const NEED_ACCESS_ID_LIST = ["/api/sso/userInfo/getInfo"];

export const HAS_RAYSYNC_USER_KEY_RETURN = [
  "/api/rendering/user/abroadUserLogin",
  "/api/rendering/user/abroadRegister",
  "/api/rendering/user/userLogin",
  "/api/rendering/user/register",
  "/api/rendering/user/register/ThirdUser",
  "/api/rendering/user/bindUnionidToUser",
  "/api/rendering/user/validate/binding/assessId",
  "/api/rendering/user/third/login",
  "/api/rendering/user/third/WxLogin",
];

export const HANDLE_SPEED_UP_LIST = [
  "/api/rendering/task/renderingTask/getRenderingTask/v2",
];

export const HANDLE_SPEED_UP_LIST_OPERATION = [
  "/api/rendering/task/commit/commitMainPictureRender", // 重提
  "/api/rendering/task/renderingTask/startTask", // 开始
  "/api/rendering/task/renderingTask/stopTask", // 停止
  "/api/rendering/task/commit/submitCloneTask", // 克隆
  "/api/rendering/task/renderingTask/recommitFailFrame", // 重提
  "/api/rendering/task/renderingTask/deleteTask", // 删除
  "/api/rendering/task/renderingTask/downLoadVaild", // 下载
  "/api/rendering/task/renderingTask/editTaskHardwareConfig", //硬件配置
  // 查看作业详情
  "/api/rendering/task/renderingTask/loadingTaskParameter",
  "/api/rendering/task/renderingTask/taskRenderingConsume",
  "/api/rendering/task/renderingTask/getFrameInfoStatus",
  "/api/rendering/task/renderingTask/taskFrameRenderingInfo",
  // 帧详情
  "/api/rendering/task/renderingTask/loadingTaskThumbnail",
  "/api/rendering/file/operate/getOutputFile",
  "/api/rendering/task/renderingTask/showLog",
  "/api/rendering/task/renderingTask/getRenderErrorInfo",
];

export const SPECIAL_HUAWEI = [
  "/api/rendering/task/renderingTask/showLog",
  "/api/rendering/file/operate/getOutputFile",
  "/api/rendering/task/renderingTask/getRenderErrorInfo",
];
